import React from 'react'
import { Flex } from '@components'
import { Button, Form, message, Select, Spin } from 'antd'
import SiderMenu from '@pages/Assembly/siderMenu'
import Breadcrumb from '@pages/Assembly/Breadcrumb'
import TitleTop from '@pages/Assembly/titleTop'
import { getLoginUser } from '@utils/NHCore'
import NHFetch from '@utils/NHFetch'

import CommonTip from '@pages/SelfHelp/common'
import NextButton from '@pages/SelfHelp/common/nextIndex'
import { mkbz } from '@pages/Assembly/siderMenu/menuObj'
import Hint from '@pages/SelfHelp/common/hint'

const FormItem = Form.Item;
const basicUrl = "/zzbd/knssq";
const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 }
};

@Form.create()

export default class StudentLoanApply extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            mkbz: 'GD052',
            hjmc: '',
            editable: true,
            update: false,
            loading: false,
            nextUrl: '',
            search: '',
            operable: true, // 是否显示环节
            nonOperationalData: {}, // 不可操作的数据

            zxdkLink: '',
            isHjLinked: false,
            xslb: null,
            initPo: {
                nd: '',
                xsid: '',
                sfsqzxdk: '',
            },
        }
    }

    componentDidMount() {
        this.queryQztjAndYlhj(operable => {
            if (operable) {
                this.checkIsZzbdHjLinked();
                // this.getXslb()
                this.getLink();
                this.getStudentLoanApplyInfo();
            }
        })
    }

    //查询前置条件和依赖环节
    queryQztjAndYlhj = callback => {
        let xsid = getLoginUser() ? getLoginUser().userId : ''
        if (!xsid) {
            this.setState({
                nonOperationalData: { nologin: true },
                operable: false
            })
            return
        }
        let zzbdhjid = this.getQueryString('pkid')
        NHFetch('/zzbd/queryQztjAndYlhj', 'GET', { xsid: xsid, zzbdhjid: zzbdhjid }).then(res => {
            if (res && res.data) {
                let kfsj = res.data['kfsj']
                let ylhj = res.data['ylhj']
                let qzhj = res.data['qzhj']
                let nohj = res.data['nohj']
                this.setState({ nonOperationalData: res.data })
                if (kfsj && kfsj['YXSJ'] != '1') {
                    this.setState({ operable: false })
                }

                if (ylhj && ylhj.length > 0) {
                    this.setState({ operable: false })
                }

                if (qzhj && qzhj.length > 0) {
                    this.setState({ operable: false })
                }

                if (nohj) {
                    this.setState({ operable: false })
                }

                if (callback) {
                    callback(this.state.operable)
                }
            }
        })
    }

    checkIsZzbdHjLinked = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        let zzbdhjid = this.getQueryString('pkid');

        NHFetch("/zzbd/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid })
            .then(res => {
                this.setState({ isHjLinked: res?.data });
            });
    };

    getLink = () => {
        NHFetch('/zzbdCommon/getCssz', "GET", { csbz: 'YXXT_ZZBD_ZXDKSQ_PCD_RKLJ' }).then(res => {
            if (res?.code === 200 && res.data) {
                this.setState({ zxdkLink: res.data });
            }
        });
    }

    getStudentLoanApplyInfo = () => {
        NHFetch(basicUrl + "/getStudentLoanApplyInfo", "GET")
            .then(res => {
                if (res) {
                    if (res.data) {
                        this.setState({
                            initPo: res.data,
                            editable: false
                        });
                    }
                }
            });
    }

    getQueryString = name => {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    }
    //获取url中传递的参数
    getUrlParams = (param) => {
        return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    };

    setMenuList = menuList => {
        let nextCount = 0
        let bz = this.state.mkbz
        menuList.map((elem, index) => {
            if (elem.HJDM == bz) {
                let hjmc = elem.HJMC
                this.setState({ hjmc: hjmc })
                nextCount = index + 1
                return
            }
        })
        let menu = menuList[nextCount]
        if (menu) {
            let hjdm = menu.HJDM
            if (hjdm.indexOf('GD') == 0) {
                let gdUrl = mkbz[hjdm]
                this.setState({
                    nextUrl: gdUrl,
                    search: 'pkid=' + menu.PKID
                })
            } else if (hjdm.indexOf('ZDY') == 0) {
                let zdyUrl = '/customLink'
                this.setState({
                    nextUrl: zdyUrl,
                    search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX
                })
            }
        } else {
            this.setState({
                nextUrl: '',
                search: ''
            })
        }
    }

    //重新加载菜单
    reloadMenu = () => {
        this.refs.siderMenu.reloadMenuList()
    }

    handleSubmit = e => {
        if (e)
            e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                return;
            }

            let sUrl = '/saveStudentLoanApplyInfo';
            if (this.state.update) {
                sUrl = '/updateStudentLoanApplyInfo';
            }
            //修改 可编辑状态，并可以update数据
            if (!this.state.editable) {
                this.setState({ update: true, editable: true });
                return
            }

            const sfsqzxdk = values.sfsqzxdk
            const xsid = getLoginUser().userId;
            const zzbdhjid = this.getUrlParams("pkid");
            let params = { xsid: xsid, zzbdhjid: zzbdhjid, formData: values };

            //请求保存或修改数据
            NHFetch(basicUrl + sUrl, 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            message.success('信息保存成功！');
                            this.reloadMenu();
                            this.getStudentLoanApplyInfo();
                            if (sfsqzxdk == '1') {
                                window.open(this.state.zxdkLink, '_blank');
                            }
                        } else {
                            message.error('信息保存失败，请重试！');
                        }
                    }
                })
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { editable, initPo } = this.state;

        return (
            <div style={{ position: 'relative' }}>
                {this.state.operable ? (
                    <div>
                        <Flex className="w1180 mt-20" align="start">
                            <SiderMenu ref={'siderMenu'} setMenuList={this.setMenuList} title="自助报到"
                                mkbz={this.state.mkbz} menuType="自助报到" />
                            <Flex.Item className="page_con_r" styleName="">
                                <Breadcrumb noLine list={[{ name: '首页', url: '/index' }, { name: '自助报到', url: '/register' }, { name: this.state.hjmc }]} />
                                <div className="box">
                                    <Hint />
                                    <TitleTop title="助学贷款申请" extra={false} />
                                    <Form onSubmit={this.handleSubmit}>
                                        <div className="p-sw">
                                            <Flex align="start" wrap="wrap">
                                                <div className="form_item">
                                                    <FormItem
                                                        {...formItemLayout}
                                                        label="是否申请助学贷款"
                                                    >
                                                        {getFieldDecorator('sfsqzxdk', {
                                                            initialValue: initPo.sfsqzxdk, placeholder: '请选择',
                                                            rules: [
                                                                {
                                                                    required: true,
                                                                    message:
                                                                        '请选择是否申请助学贷款'
                                                                }
                                                            ]
                                                        })(
                                                            editable ?
                                                                <Select placeholder="请选择">
                                                                    <Option value="1">
                                                                        是
                                                                    </Option>
                                                                    <Option value="0">
                                                                        否
                                                                    </Option>
                                                                </Select> : <span>{initPo.sfsqzxdk == 1 ? '是' : '否'}</span>
                                                        )}
                                                    </FormItem>
                                                </div>
                                            </Flex>

                                            <div className="text-center mt-50">
                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                >
                                                    {editable ? '保存' : '修改'}
                                                </Button>
                                                <NextButton nextUrl={this.state.nextUrl} search={this.state.search} />
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </Flex.Item>
                        </Flex>
                        <Spin style={{ position: 'absolute', top: '300px', left: '60%' }}
                            spinning={this.state.loading} />{' '}
                    </div>
                ) :
                    <CommonTip hjmc={'助学贷款'} key={'GD052'} mkbz="GD052" nonOperationalData={this.state.nonOperationalData} />
                }
            </div>
        )
    }

}